import { useQuery } from 'react-query';
import { getAssessmentQuestionFeedbackByMeetingAndQuestionId } from 'src/apis/assessmentQuestionFeedback';
import { GetAssessmentQuestionConfigByIdAPIResponse } from 'types';

export const useGetAssessmentQuestionFeedbackByMeetingAndQuestionIdQuery = (
	args: { questionId: string; token: string; meetingId: string; configs: string[] },
	onComplete?: (data: GetAssessmentQuestionConfigByIdAPIResponse) => void,
	handleError?: () => void,
) => {
	return useQuery({
		queryKey: ['getAssessmentQuestionConfig', args.questionId, args.token, args.meetingId],
		queryFn: async () =>
			(await getAssessmentQuestionFeedbackByMeetingAndQuestionId(
				args.questionId,
				args.token,
				args.meetingId,
			)) as GetAssessmentQuestionConfigByIdAPIResponse,
		staleTime: 0,
		enabled: !!args.questionId && !!args.meetingId && !!args.token && !args.configs.length,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onError() {
			handleError && handleError();
		},
	});
};
